// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__24d23","consentsList":"PatientConsents_consentsList__2nyoJ","consentsListEmpty":"PatientConsents_consentsListEmpty__1gJ5J"};